export const pxToRem = (px: number, base = 16) => `${px / base}rem`
